export const serializeEntityRecord = (serializer, record) => {
    return Object.fromEntries(Object.entries(record).map(([key, value]) => [
        key,
        Array.isArray(value)
            ? serializer.hierarchiesToJsonString(value)
            : serializer.toJsonString(value)
    ]));
};
//# sourceMappingURL=serialize.js.map